import * as _ from "lodash";

let store;

export const injectStore = _store => {
  store = _store;
};

const getPermissions = () => {
  const state = store.getState();
  return _.get(state, "permissions.data", {}) || {};
};

const getProfile = () => {
  const state = store.getState();
  return _.get(state, "profile.data", {}) || {};
};

const authRules = {
  isAdmin: () => {
    //return false;
    //return getProfile().interface === "ADMIN";
    return getProfile().interface === "admin";
  },

  getPermissions: () => {
    return getPermissions();
  },
  getProfile: () => {
    return getProfile();
  },
  hasPermissionByKeyAndName: (key, permissionName) => {
    if (authRules.isAdmin()) {
      return true;
    }

    const relevantPermission = _.get(
      getPermissions(),
      key + ".permissions",
      null
    );

    return (
      relevantPermission && relevantPermission.indexOf(permissionName) > -1
    );
  },
  can: (key, rule) => {
    if (authRules.isAdmin()) {
      return true;
    }

    const relevantAccess = _.get(getPermissions(), key + ".access", null);

    return relevantAccess && relevantAccess.indexOf(rule) > -1;
  },
  canModifyByKey: key => {
    return authRules.can(key, "MODIFY");
  },
  canDeleteByKey: key => {
    return authRules.can(key, "DELETE");
  },
  canViewByKey: key => {
    return authRules.can(key, "VIEW") || authRules.can(key, "VIEW");
  },
};

export default authRules;
